var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmDeleteCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 10.746,
    viewBox: "0 0 14 10.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Check",
    d: "M15.762,5.383a.81.81,0,0,0-1.146-1.146L6.066,12.788,3.383,10.107a.81.81,0,1,0-1.146,1.146l3.215,3.216c.013.014.025.028.039.041a.812.812,0,0,0,1.148,0,.463.463,0,0,0,.039-.041Z",
    transform: "translate(-2 -4)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmDeleteCheck);
export default __webpack_public_path__ + "static/media/confirm-delete-check.f298aeb647ed85ddbb7fc6bc72c537f8.svg";
export { ForwardRef as ReactComponent };